<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="close"></div>
        </div>
        <div class="tab">
          <h3 v-html="text[resourceType][actionType].title"></h3>
          <p>{{ text[resourceType][actionType].paragraph }}</p>
          <form @submit.prevent="confirm()">
            <p
              class="description"
              v-html="text[resourceType][actionType].description"
            ></p>
            <input
              :placeholder="name"
              v-model="confirmMessage"
              type="text"
              required
            />
            <div class="footer">
              <button
                class="btn-black"
                :disabled="
                  getCleanString(confirmMessage) != getCleanString(name)
                "
                type="submit"
              >
                {{ actionType == 'leave' ? 'Verlassen' : 'Löschen' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'removeConfirmationModal',
  data() {
    return {
      confirmMessage: '',
      text: {
        flow: {
          leave: {
            title: 'Flow <b>' + this.name + '</b> verlassen',
            paragraph: '',
            description:
              'Bitte geben Sie im untenstehenden Feld den Namen des zu verlassenden Flows <b>' +
              this.name +
              '</b> ein.',
          },
          remove: {
            title: 'Flow <b>' + this.name + '</b> löschen',
            paragraph: 'Gelöschte Flows können nicht wiederhergestellt werden',
            description:
              'Bitte geben Sie im untenstehenden Feld den Namen des zu löschenden Flows <b>' +
              this.name +
              '</b> ein um den Flow endgültig zu löschen.',
          },
        },
        flows: {
          remove: {
            title: 'Flow',
            paragraph: 'Gelöschte Flows können nicht wiederhergestellt werden',
            description: `Dis  bar`,
          },
        },
        database: {
          leave: {
            title: 'Datenbank <b>' + this.name + '</b> verlassen',
            paragraph: '',
            description:
              'Bitte geben Sie im untenstehenden Feld den Namen der zu verlassenden Datenbank <b>' +
              this.name +
              '</b> ein.',
          },
          remove: {
            title: 'Datenbank <b>' + this.name + '</b> löschen',
            paragraph:
              'Gelöschte Datenbanken können nicht wiederhergestellt werden',
            description:
              'Bitte geben Sie im untenstehenden Feld den Namen der zu löschenden Datenbank <b>' +
              this.name +
              '</b> ein um die Datenbank endgültig zu löschen.',
          },
        },
      },
    };
  },
  props: ['id', 'name', 'resourceType', 'actionType', 'flows'],
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      if (this.actionType == 'leave') {
        this.$emit('confirmLeave', this.id);
        this.$emit('close');
      } else if (this.actionType == 'remove') {
        this.$emit('confirmRemove', this.id);
        this.$emit('close');
      }
    },
    getCleanString(value) {
      try {
        // Remove non-printable-chars and emojis
        // eslint-disable-next-line no-control-regex
        value = value.replace(/[^\x00-\x7F]/g, ' ').trim();
      } catch {
        /*Nothing*/
      }
      return value;
    },
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 30%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  position: fixed;
  left: 35%;
  top: 7%;
  min-height: 550px;
  height: 500px;
  overflow: scroll;
  text-transform: none;
}

/* Style that has no refference*/
.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

h1 {
  padding-top: 50px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 12px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: #70787e;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  border-top: 1px solid #eaecf1;
  background: #fff;
  padding: 38px 40px 2px 40px;
  min-height: 190px;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}

.btn-black {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-bottom: 25px;
  margin-top: 5px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.btn-black:hover {
  color: #fff;
  border: 3px solid #353434;
  background-color: #353434;
}

.btn-black:disabled {
  background: #3a3b3b88;
  cursor: not-allowed;
}

p {
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  color: #70787e;
  margin: 25px 0px 25px 0px;
}

.tab .description {
  font-size: 13px;
  margin: 0;
  margin-bottom: 25px;
}

.tab .description >>> b {
  white-space: nowrap;
}
label {
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  padding-top: 0;
  padding-bottom: 9px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #464d5d;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 300;
  width: 50%;
}

input,
select {
  border-radius: 0;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  width: 100%;
  margin-bottom: 0;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}
</style>
